import { type DatabaseChangeType } from '@databases/types/redux';

import { getValueId } from '../../../../utils';
import { type YJSChangeHandler } from '../../types';

export const deleteField: YJSChangeHandler<DatabaseChangeType.DELETE_FIELD> = ({
  ydb,
  change,
}) => {
  ydb.mutate((db) => {
    db.deleteField(change.fieldId);

    db.views.forEach((viewId: string) => {
      db.viewsById[viewId].removeFieldVisibilityField(change.fieldId, db.fields);
      db.viewsById[viewId].removeCalculation(change.fieldId);
      db.viewsById[viewId].sorts.deleteSortForFieldId(change.fieldId);
    });

    Object.keys(db.entriesById).forEach((entryId) => {
      db.entriesById[entryId].removeValue(change.fieldId);
    });

    // Remove all comments on the field
    db.entries.forEach((entryId) => {
      const valueId = getValueId(entryId, change.fieldId);

      if (valueId in db.commentThreads) {
        db.removeCommentsOnValue(valueId);
      }
    });
  });
};
